/** An option of what stands under me that sits at the bottom left, mirroring Build: Values. */
import type { JSX } from 'react';

import { pressOption, type TileOption } from '@game/options/options';
import type { TileFacts } from '@game/planet/tile';
import { haptic } from '@platform/haptics';
import { SideButton } from '@ui/components/SideButton';
import { useGame } from '@ui/hooks';

import { optionLook } from './optionLook';

/** The options that sit at the side; the rest go in the middle. */
export const isSideOption = (option: TileOption): boolean => option.kind === 'info';

export function SideOption({ option, here }: { option: TileOption; here: TileFacts }): JSX.Element {
  const game = useGame();
  const look = optionLook(option, here);
  return (
    <SideButton
      icon={'icon' in look.art ? look.art.icon : 'bars'}
      name={look.label}
      aria={look.aria}
      disabled={!look.enabled}
      color={look.color}
      gauge={look.gauge}
      onPress={() => {
        if (pressOption(game, option)) haptic('select');
      }}
      data={{ 'data-option': option.kind }}
    />
  );
}
